<template>
  <div class="d-flex flex-row gap-2 justify-content-between align-items-center">
    <CButton
      variant="outline"
      color="primary"
      size="sm"
      :disabled="!canEdit"
      v-on:click="boxModalOpen"
      class="border-0"
    >
      <font-awesome-icon icon="box" class="" />
    </CButton>
    <dropdown-menu :items="actions" :select="onActionSelect">
      <font-awesome-icon icon="ellipsis-h"
    /></dropdown-menu>
  </div>
</template>

<script>
import EventBus from "../../../../../../helpers/EventBus";
import { filtersMap } from "../../filtersMap";
import { PERMS } from "../../../../../../helpers/acl";
import {
  INCIDENT_ENTITY_TYPE,
  INCIDENT_TYPE,
  ORDER_ACTION,
} from "../../../../../../config/global";

export default {
  name: "OrdersTableActions",

  data() {
    const canEdit = this.canView(PERMS.ORDERS_EDIT);

    return {
      actions: [
        {
          id: ORDER_ACTION.FILTER,
          text: this.$t(
            "role.orders.manage.ddmp.detail.orders.table.actions.filter"
          ),
        },
        {
          id: ORDER_ACTION.ADD,
          text: this.$t(
            "role.orders.manage.ddmp.detail.orders.table.actions.addProduct"
          ),
          disabled: !canEdit,
        },
        {
          id: ORDER_ACTION.DONE,
          text: this.$t(
            "role.orders.manage.ddmp.detail.orders.table.actions.markAsDelivered"
          ),
          disabled: !canEdit,
        },
        {
          id: ORDER_ACTION.UNDONE,
          text: this.$t(
            "role.orders.manage.ddmp.detail.orders.table.actions.markAsNonDelivered"
          ),
          disabled: !canEdit,
        },
        {
          id: ORDER_ACTION.INCIDENT,
          text: this.$t(
            "role.orders.manage.ddmp.detail.delivery.table.products.table.actions.openIncident"
          ),
          disabled: !canEdit,
        },
        {
          id: ORDER_ACTION.CANCELLATION,
          text: this.$t(
            "role.orders.manage.ddmp.detail.orders.table.actions.canceled"
          ),
          disabled: !canEdit,
        },
      ],
    };
  },
  computed: {
    canEdit() {
      return this.canView(PERMS.ORDERS_EDIT);
    },
  },
  methods: {
    boxModalOpen: function () {
      EventBus.$emit("orders:addBoxes", this.data.order);
    },

    onActionSelect: function (args) {
      const { id } = args.item;

      const porders = [this.data.id];

      const onSuccess = (response) => {
        EventBus.$emit("orders:refresh");
      };

      if (id === ORDER_ACTION.ADD) {
        // const orderId = this.data.order.order.id;
        // const param = { id: orderId, label: orderId };
        // // this.$store.commit("rounds/updateOrderId", param);
        // // EventBus.$emit("orders:applyFilters");
        // console.log(this.data.order)
        // Apri modal per aggiunta prodotto
        EventBus.$emit("orders:addnew", this.data.order);
      }

      if (id === ORDER_ACTION.FILTER) {
        const orderId = this.data.order.order.id;
        const param = { id: orderId, label: orderId };
        this.$store.commit("rounds/updateOrderId", param);
        EventBus.$emit("orders:applyFilters");
      }

      if (id === ORDER_ACTION.DONE) {
        // console.log(this.data)
        let nextStatus = filtersMap("ddmp.statusCode.next");
        if (this.data.direct_delivery) {
          nextStatus = filtersMap("ddmiIsland.statusCode.next");
        }
        this.$store
          .dispatch("rounds/updateStatusBatch", {
            status: nextStatus,
            porders,
          })
          .then(onSuccess);
      }

      if (id === ORDER_ACTION.UNDONE) {
        this.$store
          .dispatch("rounds/updateStatusBatch", {
            status: filtersMap("ddmp.statusCode.prev"),
            porders,
          })
          .then(onSuccess);
      }

      if (id === ORDER_ACTION.INCIDENT) {
        this.$store.commit("incidents/createResetAllEntities");
        this.$store.commit("incidents/createAddEntities", {
          entities: [
            { type: INCIDENT_ENTITY_TYPE.PORDERS, items: [{ ...this.data }] }, //FIXME
          ],
          type: INCIDENT_TYPE.INCIDENT,
          show: true,
        });
      }

      if (id === ORDER_ACTION.CANCELLATION) {
        this.$store.commit("incidents/createResetAllEntities");
        this.$store.commit("incidents/createAddEntities", {
          entities: [
            { type: INCIDENT_ENTITY_TYPE.PORDERS, items: [{ ...this.data }] },
          ],
          type: INCIDENT_TYPE.CANCELLATION,
          show: true,
        });
      }
    },

    canView(perm) {
      return this.$store.getters["connections/havePermission"](perm);
    },
  },
};
</script>
